import { useEffect, useRef, useState } from 'react'
import { Button, Container, Modal, Row, Spinner } from 'react-bootstrap'
import OtpInput from 'react-otp-input'
import BaseModal from './BaseModal'
import loginStep2 from 'assets/images/login-step2.svg'
import { useTranslation } from 'react-i18next'
import {
	useBuyPackage,
	useLoginSMS,
	useRequestOTP,
	useShopOTP,
} from 'dataLayer/user'
import { useDispatch } from 'react-redux'
import { reloadHeader, showSnackbar } from 'store/actions'
import axios from 'axios'
import { API_PATHS } from 'config/routes'
import i18n from 'i18n'
import { handleFlyBoatRacing, handleFlyItem, handleFlyWater } from 'utils/helpers'
import {
	getCheckEventBoatRacingQuery,
	getCheckEventBunpimayQuery,
	getCheckEventWaterQuery,
} from 'dataLayer/game'
import { useQuery } from 'react-query'
import iconDrop from 'assets/images/eventWater/iconDrop.png'
import iconSpin from 'assets/images/eventBoatRacing/iconSpin.png'
import iconWaterGun from 'assets/images/eventBunpimay/gunBody.png'

function OTPConfirmModal({
	show,
	onHide,
	phone,
	isShopPage,
	dataSelect,
	transactionId,
	tabValue,
	isChangePass = false,
	handleChangePass = () => { },
	handleResendPassOTP = () => { },
	handleLocalstorage = () => { },
	...otherProps
}) {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const [dataSelectPackage, setDataSelectPackage] = useState({})
	const [dataTransactionId, setDataTransactionId] = useState('')
	const [typeGetResend, setTypeGetResend] = useState('')
	const [checkNullOTP, setCheckNullOTP] = useState(false)
	const [disabledConfirm, setDisabledConfirm] = useState(false)
	const [otp, setOtp] = useState('')
	const {
		data: eventWater,
		isLoading: isLoadingEvent,
		refetch: refetchEvent,
	} = useQuery(getCheckEventWaterQuery())

	const { data: eventBoatRacing, refetch: refetchEventBoatRacing } = useQuery(
		getCheckEventBoatRacingQuery(),
	)
	const { data: eventBunpimay, refetch: refetchEventBunpimay } = useQuery(
		getCheckEventBunpimayQuery(),
	)
	const errorRef = useRef(null)
	const { mutate, data, isLoading } = useLoginSMS(
		data => {
			onHide()
			axios.get(API_PATHS.getUser).then(res => {
				const laguageUser = res?.data.data.language
				if (laguageUser) {
					i18n.changeLanguage(laguageUser)
				} else {
					i18n.changeLanguage('la')
				}
			})
		},
		result => {
			if (errorRef.current) {
				errorRef.current.innerText = data?.message
			}
		},
	)
	const { mutate: fnLogin } = useRequestOTP(
		data => {
			dispatch(showSnackbar(true, t('modal.success'), 'success'))
		},
		error => {
			dispatch(showSnackbar(true, error?.message || t('modal.error'), 'error'))
		},
	)

	useEffect(() => {
		setDataSelectPackage(dataSelect)
		setDataTransactionId(transactionId)
		setCheckNullOTP(false)
	}, [dataSelect, transactionId])

	const {
		mutate: shopOTP,
		data: dataShop,
		isLoading: isLoadingShop,
	} = useShopOTP(
		result => {
			if (typeGetResend !== 'resend') {
				onHide()
				handleLocalstorage && handleLocalstorage({ isRegisted: 1 })
				dispatch(reloadHeader(new Date() * 1 + 1))
				if (
					eventWater?.is_show &&
					!eventWater?.is_finished &&
					(result?.returnCode == 200 ||
						result?.returnCode == 0 ||
						result?.returnCode == 207 ||
						result?.returnCode == 208)
				) {
					handleFlyWater(iconDrop)
				}
				if (
					eventBoatRacing?.is_show &&
					!eventBoatRacing?.is_finished &&
					(result?.returnCode == 200 ||
						result?.returnCode == 0 ||
						result?.returnCode == 207 ||
						result?.returnCode == 208)
				) {
					handleFlyBoatRacing(iconSpin, 2)
				}
				if (
					eventBunpimay?.is_show &&
					!eventBunpimay?.is_finished &&
					(result?.returnCode == 200 ||
						result?.returnCode == 0 ||
						result?.returnCode == 207 ||
						result?.returnCode == 208)
				) {
					handleFlyItem(iconWaterGun, 'icon-event-bunpimay', 'show-item-fly')
				}
			}
			setDataTransactionId(result?.content)
			dispatch(showSnackbar(true, t('modal.success'), 'success'))
		},
		error => {
			if (errorRef.current) {
				errorRef.current.innerText = error?.message
			}
			dispatch(showSnackbar(true, error?.message || t('modal.error'), 'error'))
		},
	)
	const {
		mutate: buyPackage,
		data: dataPackage,
		isLoading: isLoadingPackage,
	} = useBuyPackage(
		result => {
			if (typeGetResend !== 'resend') {
				onHide()
				handleLocalstorage &&
					handleLocalstorage({ packageCurrent: dataSelectPackage?.name })
				dispatch(reloadHeader(new Date() * 1 + 1))
				if (
					eventWater?.is_show &&
					!eventWater?.is_finished &&
					(result?.returnCode == 200 || result?.returnCode == 0)
				) {
					handleFlyWater(iconDrop)
				}
				if (
					eventBunpimay?.is_show &&
					!eventBunpimay?.is_finished &&
					(result?.returnCode == 200 ||
						result?.returnCode == 0)
				) {
					handleFlyItem(iconWaterGun, 'icon-event-bunpimay', 'show-item-fly')
				}
				if (
					eventBoatRacing?.is_show &&
					!eventBoatRacing?.is_finished &&
					(result?.returnCode == 200 || result?.returnCode == 0)
				) {
					if (dataSelectPackage?.command == 'ARG01') {
						handleFlyBoatRacing(iconSpin, 2)
					} else if (dataSelectPackage?.command == 'ARG02') {
						handleFlyBoatRacing(iconSpin, 3)
					} else if (dataSelectPackage?.command == 'ARG03') {
						handleFlyBoatRacing(iconSpin, 7)
					} else if (dataSelectPackage?.command == 'ARG04') {
						handleFlyBoatRacing(iconSpin, 20)
					} else if (dataSelectPackage?.command == 'ARG05') {
						handleFlyBoatRacing(iconSpin, 45)
					} else {
						handleFlyBoatRacing(iconSpin)
					}
				}
			}
			setDataTransactionId(result?.content)
			dispatch(showSnackbar(true, t('modal.success'), 'success'))
		},
		result => {
			if (errorRef.current) {
				errorRef.current.innerText = result?.message
			}
			dispatch(showSnackbar(true, result?.message || t('modal.error'), 'error'))
		},
	)
	useEffect(() => {
		if (
			(dataPackage && parseInt(dataPackage?.responseCode) !== 200) ||
			(dataShop && parseInt(dataShop?.responseCode) !== 200)
		) {
			setDisabledConfirm(true)
			setOtp('')
		}
	}, [dataPackage, dataShop])
	useEffect(() => {
		if (errorRef.current) {
			errorRef.current.innerText = ''
		}
	}, [show])

	useEffect(() => {
		setOtp('')
	}, [show])
	const handleChangeOtp = otp => {
		setOtp(otp)
	}
	const handleSendOTP = () => {
		if (otp === null || otp === '') {
			setCheckNullOTP(true)
			dispatch(showSnackbar(true, t('modal.shop.error_null_OTP'), 'error'))
		} else {
			setCheckNullOTP(false)
			setTypeGetResend('confirmOTP')
		}
	}
	useEffect(() => {
		if (typeGetResend === 'resend') {
			setTypeGetResend('')
			if (tabValue === 2) {
				buyPackage({
					package_id: dataSelectPackage.packageCode,
					command: dataSelectPackage.command,
				})
			} else if (tabValue === 1) {
				shopOTP({
					package_id: dataSelectPackage.packageCode,
				})
			}
		} else if (typeGetResend === 'confirmOTP') {
			setTypeGetResend('')
			if (tabValue === 2) {
				buyPackage({
					package_id: dataSelectPackage.packageCode,
					command: dataSelectPackage.command,
					otp: otp,
					transaction_id: dataTransactionId,
				})
			} else if (tabValue === 1) {
				shopOTP({
					transaction_id: dataTransactionId,
					package_id: dataSelectPackage.packageCode,
					otp: otp,
				})
			}
		}
	}, [typeGetResend])
	const handleResendOtp = () => {
		setTypeGetResend('resend')
		setDisabledConfirm(false)
	}
	const handleResendOtpMobile = () => {
		fnLogin({ msisdn: phone })
	}

	function handleLogin() {
		mutate({
			msisdn: phone,
			otp: otp,
			grant_type: 'login_with_sms',
		})
	}
	return (
		<>
			<BaseModal show={show} onHide={onHide} {...otherProps}>
				<Container className="otp-modal" fluid>
					<Modal.Header>
						<Modal.Title id="contained-modal-title-vcenter">
							{isShopPage === 'shopPage/PackageCard'
								? t('modal.shop.title_modal_OTP')
								: t('modal.login.title_OTP')}
						</Modal.Title>
						<Modal.Body>
							<img
								src={loginStep2}
								alt="Login step 2"
								className="login-step mx-auto mb-3"
							/>
							<p>
								{t('modal.login.otp_sendtophone').replace('_PHONE_', phone)}
							</p>
						</Modal.Body>
					</Modal.Header>
					<Modal.Body className={disabledConfirm && 'body-err'}>
						{!disabledConfirm && (
							<OtpInput
								containerStyle="otp-group"
								inputStyle="otp-input"
								value={otp}
								onChange={handleChangeOtp}
								numInputs={6}
								isInputNum={true}
							/>
						)}
						{/* {parseInt(data?.responseCode) === 403 && !checkNullOTP ? (
							<p className="error-otp" ref={errorRef}>
								{data?.message}
							</p>
						) : null} */}
						{parseInt(dataShop?.responseCode) !== 200 && !checkNullOTP ? (
							<p className="error-otp" ref={errorRef}>
								{dataShop?.message}
							</p>
						) : null}
						{parseInt(dataPackage?.responseCode) !== 200 && !checkNullOTP ? (
							<p className="error-otp" ref={errorRef}>
								{dataPackage?.message}
							</p>
						) : null}
						{checkNullOTP ? (
							<p className="error-otp" ref={errorRef}>
								{t('modal.shop.error_null_OTP')}
							</p>
						) : null}
					</Modal.Body>
					<Modal.Footer>
						{!disabledConfirm && (
							<Button
								variant="secondary"
								onClick={
									isShopPage === 'shopPage/PackageCard'
										? handleSendOTP
										: isChangePass
											? () => {
												handleChangePass(otp)
											}
											: handleLogin
								}
								disabled={isLoading || isLoadingShop}
							>
								{t('modal.login.otp_confirm')}
								{isLoading || isLoadingShop || isLoadingPackage ? (
									<Spinner animation="border" role="status"></Spinner>
								) : null}
							</Button>
						)}
					</Modal.Footer>
					{/* TODO: Resend countdown 1 minute */}
					<Row className="login-mobile" style={{ marginTop: 0 }}>
						<p className="otp-resend big-resend ">
							{t('modal.login.otp_notreceived')}{' '}
							<a
								onClick={
									isShopPage === 'shopPage/PackageCard'
										? handleResendOtp
										: isChangePass
											? handleResendPassOTP
											: handleResendOtpMobile
								}
							>
								{t('modal.login.otp_resend')}
							</a>
						</p>
					</Row>
				</Container>
			</BaseModal>
		</>
	)
}

export default OTPConfirmModal
